var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    style: {
      fill: "currentColor"
    },
    viewBox: "0 0 445 445",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 99.254h80v16H16zM88 233.516v25.738a31.936 31.936 0 0 1-8.6 21.846l49.967 15.366 14.107-45.878zM112 77.254v-10H0v10a6.006 6.006 0 0 0 6 6h100a6.006 6.006 0 0 0 6-6zM159.941 197.06l-3.444 11.2 39.3 48.161a153.622 153.622 0 0 0 159.756 51l9.4-2.584h.016l45.776-12.583a8.015 8.015 0 0 1 4.473.067 30.651 30.651 0 0 0 30.54-7.345zM40 259.254a16.019 16.019 0 0 0 16 16 15.845 15.845 0 0 0 1.8-.1h.008A15.982 15.982 0 0 0 72 259.254v-128H40zM373.506 319.083l-19.447 63.234h.009a47.985 47.985 0 0 0 53.881-72.707z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.955 321.427a169.09 169.09 0 0 1-81.557-54.89l-20.4-25-1.877 6.1-23.52 76.46 168.219 51.74 14.458-47q-2.735.088-5.47.091a169.517 169.517 0 0 1-49.853-7.5zm-92.061-3.206-15.293-4.7 4.7-15.293 15.293 4.7zm53.524 16.463-38.231-11.76 4.7-15.293 38.232 11.76zM337.463 327.411l-16.345 53.143 15.3 4.7.1-.338 18.729-60.892a169.859 169.859 0 0 1-17.784 3.387zM334.143 131.254a71.846 71.846 0 0 1 66.474 44.306l14.766-6.16a88.02 88.02 0 0 0-162.481 0l14.766 6.16a71.847 71.847 0 0 1 66.475-44.306z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m371.074 187.87 14.766-6.16a56.011 56.011 0 0 0-103.395 0l14.766 6.16a40.012 40.012 0 0 1 73.863 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m311.99 194.02 14.766 6.16a8 8 0 0 1 14.773 0l14.766-6.16a24 24 0 0 0-44.305 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.9b4ab2f8f715038a3e12879fc100d395.svg";
export { ForwardRef as ReactComponent };